// extracted by mini-css-extract-plugin
export default {"content":"YShhHbmWYP","title":"l6M_ptot4_","preview":"Hx8fbqvi01","errorContainer":"kef4ARZknr","footerDivider":"N7L89UXa_B","skeletonParagraph":"hLuN_BFYKb"};